import React from "react";
import styled from "@emotion/styled/macro";
import {
  Button,
  Typography,
  tokens,
  useSingletonMobileMediaQuery,
} from "@sunrun/experience-ui-components";

const StepBody = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ isMobile }) => (isMobile ? "12px" : "20px")};
  width: 100%;
`;

const HeaderRow = styled.div<{ isMobile?: boolean }>`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${({ isMobile }) => (isMobile ? "8px" : "40px")};
  width: 100%;
`;

const HeaderText = styled.div<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ isMobile }) => (isMobile ? "4px" : "6px")};
  flex: 1;
  min-width: 0;
`;

type StepHeaderProps = {
  title: string;
  description: string;
  onUpdate: () => void;
};

const StepHeader: React.FC<StepHeaderProps> = ({
  title,
  description,
  onUpdate,
}) => {
  const isMobile = useSingletonMobileMediaQuery();

  return (
    <HeaderRow isMobile={isMobile}>
      <HeaderText isMobile={isMobile}>
        <Typography
          color={tokens.BRAND_HERO_BLUE}
          size={isMobile ? tokens.FONT_SIZE_1 : tokens.FONT_SIZE_3}
          fontWeight="medium"
        >
          {title}
        </Typography>
        <Typography
          color={tokens.BRAND_HERO_BLUE}
          size={tokens.FONT_SIZE_0}
          fontWeight="regular"
        >
          {description}
        </Typography>
      </HeaderText>
      <Button
        color="secondary"
        size="sm"
        customTestId="confirm-names-update"
        onClick={onUpdate}
      >
        Update
      </Button>
    </HeaderRow>
  );
};

export { StepBody, HeaderRow, HeaderText, StepHeader };
export type { StepHeaderProps };
